/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Asset Source Type is the type of the asset.
 *
 */
export var AssetSourceType;
(function (AssetSourceType) {
    AssetSourceType["MACHINE"] = "MACHINE";
    AssetSourceType["ESS"] = "ESS";
})(AssetSourceType || (AssetSourceType = {}));
